<a
  [appRouteLink]="route"
  (onRouteClick)="handleSmartClick($event)"
  [ngClass]="customClass"
  [class]="isActive ? activeClass : ''"
>
  <ng-content></ng-content>
</a>
